// Ensure window.fetch has both getter and setter across prototypes in iframe/strict environments
if (typeof window !== 'undefined' && window.fetch) {
  try {
    const rawFetch = window.fetch;
    let currentFetch = typeof rawFetch === 'function' ? rawFetch.bind(window) : rawFetch;
    const desc: PropertyDescriptor = {
      get: () => currentFetch,
      set: (fn: any) => { currentFetch = fn; },
      configurable: true,
      enumerable: true,
    };

    try {
      Object.defineProperty(window, 'fetch', desc);
    } catch {
      // Gracefully continue
    }

    let p = window as any;
    while (p && p !== Object.prototype) {
      try {
        const d = Object.getOwnPropertyDescriptor(p, 'fetch');
        if (d && (!d.writable || !d.set)) {
          Object.defineProperty(p, 'fetch', desc);
        }
      } catch {
        // Gracefully continue
      }
      p = Object.getPrototypeOf(p);
    }
  } catch {
    // Continue cleanly
  }
}

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
